import CheckoutServices from '@/services/Checkout'
import axios from 'axios'
import { checkoutMethods } from '@/utils/helpers/checkout-helper'
import { isObjectNotEmptyOrNull } from '@/utils/helpers/object-helper'
import { isArrayNotNullOrEmpty } from '@/utils/helpers/array-helper'

let availabilityRequest = null
let courierRequest = null
let availabilityGeneration = 0
let courierGeneration = 0

const requestKey = payload => JSON.stringify(payload)

const getCartGroupId = (cart, fulfilled) => {
  if (fulfilled || !cart.store) { return cart.id }
  return cart.store.id || cart.id
}

const mergeCarts = (currentCarts, nextCarts) => {
  const carts = new Map()
  currentCarts.concat(nextCarts || []).forEach(cart => carts.set(cart.id, cart))
  return Array.from(carts.values())
}

const cancelRequest = (request) => {
  if (!request) { return }
  clearTimeout(request.timer)
  if (request.source) { request.source.cancel() }
  request.resolve(null)
}

export const state = () => ({
  pageTakeInStore: false,
  enableShipping: true,
  scheduleStoreBranch: [],
  storeBranch: [],
  storeBranchPAS: [],
  shippingCourier: [],
  listPaymentMethods: [],
  installments: [],
  vouchers: [],
  listTotalPayment: 0,
  selectedBank: [],
  selectedAddress: {},
  branchSelected: 0,
  orderPayload: {},
  listItem: {},
  paymentDetail: {},
  selectedCourier: {},
  noteShipping: '',
  onCheck: false,
  usePoint: false,
  shippingCourierLoading: false,
  shippingCourierError: false,
  // All New Checkout
  isLoading: false,
  checkoutMethodAvailability: {
    shipping: null,
    pickup: null
  },
  checkoutMethod: checkoutMethods.shipping.value,
  checkoutMethodChanging: false,
  checkoutAvailability: {},
  checkoutAvailabilityLoading: false,
  availableCartsForm: [],
  selectedPaymentMethod: {},
  checkoutCounter: {
    success: 0,
    error: 0
  }
})

export const mutations = {
  setTakeInStore (state, payload) {
    state.pageTakeInStore = payload
  },
  setEnableShipping (state, payload) {
    state.enableShipping = payload
  },
  setScheduleStoreBranch (state, payload) {
    state.scheduleStoreBranch = payload
  },
  setStoreBranch (state, payload) {
    state.storeBranch = payload
    state.branchSelected = 0
  },
  setStoreBranchPAS (state, payload) {
    state.storeBranchPAS = payload
    if (state.pageTakeInStore) {
      state.branchSelected = 0
    }
  },
  setSelectedBranch (state, payload) {
    state.branchSelected = payload
  },
  setUnshiftBranch (state, payload) {
    state.storeBranch.splice(state.branchSelected, 1)
    state.storeBranch.splice(0, 0, payload)
  },
  setShippingCourier (state, payload) {
    const couriers = payload
    state.shippingCourier = couriers.map((courier) => {
      return {
        shippingCouriers: courier.shipping_couriers,
        storeBranchId: courier.store_branch_id
      }
    })
  },
  setShippingCourierLoading (state, payload) {
    state.shippingCourierLoading = payload
  },
  setShippingCourierError (state, payload) {
    state.shippingCourierError = payload
  },
  modifyShippingCourier (state, payload) {
    const { storeBranchId, fields } = payload

    const cartGroupStoreBranchIdx = state.shippingCourier.findIndex((branch) => {
      return branch.storeBranchId === storeBranchId
    })

    if (cartGroupStoreBranchIdx === -1) {
      return
    }

    fields.forEach((field) => {
      const { name, value } = field

      state.shippingCourier[cartGroupStoreBranchIdx][name] = value

      if (name === 'selectedBranch') {
        state.shippingCourier[cartGroupStoreBranchIdx].previousStoreBranchId = state.shippingCourier[cartGroupStoreBranchIdx].storeBranchId
        state.shippingCourier[cartGroupStoreBranchIdx].storeBranchId = value.id
      }
    })
  },
  setListPaymentMethods (state, payload) {
    state.listPaymentMethods = payload
    state.listTotalPayment = payload.length
  },
  setSelectedBank (state, payload) {
    state.selectedBank = payload
  },
  setSelectedAddress (state, payload) {
    state.selectedAddress = payload
    state.branchSelected = 0
  },
  setOrderPayload (state, payload) {
    state.orderPayload = payload
  },
  setAvailibility (state, payload) {
    state.shippingCourier = payload.courier_costs
    state.listItem = payload.carts
    state.paymentDetail = payload.payment_detail
    state.installments = payload.credit_card
      ? payload.credit_card.installments
      : []
    state.vouchers = payload.vouchers
  },
  setSelectedCourier (state, payload) {
    state.selectedCourier = payload
  },
  setNoteShipping (state, payload) {
    state.noteShipping = payload
  },
  setOnCheck (state) {
    state.onCheck = !state.onCheck
  },
  setUsePoint (state, payload) {
    state.usePoint = payload
  },
  setLoading (state, payload) {
    state.isLoading = payload
  },
  // All New Checkout
  setPaymentDetail (state, payload) {
    state.paymentDetail = payload
  },
  setCheckoutMethod (state, payload) {
    state.checkoutMethod = payload
  },
  setCheckoutMethodAvailability (state, payload) {
    state.checkoutMethodAvailability = payload
  },
  setCheckoutMethodChanging (state, payload) {
    state.checkoutMethodChanging = payload
  },
  setCheckoutAvailability (state, payload) {
    state.checkoutAvailability = payload
  },
  setCheckoutAvailabilityLoading (state, payload) {
    state.checkoutAvailabilityLoading = payload
  },
  setAvailableCartsForm (state, payload) {
    const { availableCarts, checkoutGroups = [] } = payload

    if (!isObjectNotEmptyOrNull(availableCarts) || !isArrayNotNullOrEmpty(availableCarts.store_branches)) {
      state.availableCartsForm = []
      return
    }

    const formsByGroupId = new Map()

    state.availableCartsForm.forEach((form) => {
      formsByGroupId.set(form.cartGroupId, form)
    })

    state.availableCartsForm = availableCarts.store_branches.reduce((forms, cart) => {
      const cartGroupId = getCartGroupId(cart, state.checkoutAvailability.is_fulfilled)
      const oldForm = formsByGroupId.get(cartGroupId)
      const formIdx = forms.findIndex(form => form.cartGroupId === cartGroupId)
      const currentForm = formIdx > -1 ? forms[formIdx] : null
      const previousForm = currentForm || oldForm
      const noteGroup = checkoutGroups.find(group =>
        group.note !== undefined && (cart.carts || []).some(item => group.cart_ids.includes(item.id))
      )
      const form = {
        ...(previousForm || {}),
        cartGroupId,
        storeId: cart.store ? cart.store.id : '',
        storeBranchId: (previousForm && previousForm.storeBranchId) || cart.id,
        selectedBranch: previousForm ? previousForm.selectedBranch : {},
        selectedCourier: previousForm ? previousForm.selectedCourier : {},
        shippingPickupNote: previousForm ? previousForm.shippingPickupNote : (noteGroup ? noteGroup.note : ''),
        carts: mergeCarts(currentForm ? currentForm.carts : [], cart.carts)
      }

      if (formIdx > -1) {
        forms.splice(formIdx, 1, form)
      } else {
        forms.push(form)
      }

      return forms
    }, [])
  },
  editAvailableCartsForm (state, payload) {
    const { cartGroupId, fields } = payload

    const cartsFormIdx = state.availableCartsForm.findIndex((cartForm) => {
      return cartForm.cartGroupId === cartGroupId
    })

    if (cartsFormIdx === -1) {
      return
    }

    fields.forEach((field) => {
      const { name, value } = field

      state.availableCartsForm[cartsFormIdx][name] = value

      if (name === 'selectedBranch') {
        state.availableCartsForm[cartsFormIdx].storeBranchId = value.id
      }
    })
  },
  resetAvailableCartsForm (state, payload) {
    state.availableCartsForm = []
  },
  resetCheckoutMethodSelections (state) {
    state.checkoutMethodChanging = true
    cancelRequest(courierRequest)
    courierRequest = null
    courierGeneration++
    state.shippingCourier = []
    state.shippingCourierLoading = false
    state.shippingCourierError = false
    state.availableCartsForm = state.availableCartsForm.map(form => ({
      ...form,
      storeBranchId: '',
      selectedBranch: {},
      selectedCourier: {}
    }))
  },
  setSelectedPaymentMethod (state, payload) {
    state.selectedPaymentMethod = payload
  },
  setCheckoutCounter (state, payload) {
    const { field, value } = payload

    state.checkoutCounter[field] = value
  },
  resetCheckoutCounter (state, payload) {
    state.checkoutCounter = {
      success: 0,
      error: 0
    }
  }
}

export const getters = {
  pickupAtStore (state) {
    return state.checkoutMethod === checkoutMethods.pickup.value
  },
  checkoutAvailableCarts (state) {
    if (!isObjectNotEmptyOrNull(state.checkoutAvailability)) {
      return []
    }

    if (!isObjectNotEmptyOrNull(state.checkoutAvailability.available_carts)) {
      return []
    }

    return state.checkoutAvailability.available_carts.store_branches
  },
  unavailableCarts (state) {
    if (!isObjectNotEmptyOrNull(state.checkoutAvailability)) {
      return {}
    }

    const unavailableData = Object.keys(state.checkoutAvailability)
    .filter(key => key.includes('unavailable'))
    .reduce((obj, key) => {
        obj[key] = state.checkoutAvailability[key];
        return obj;
    }, {})

    return unavailableData
  },
  checkoutPaymentMethods (state) {
    if (!isObjectNotEmptyOrNull(state.checkoutAvailability)) {
      return []
    }

    return state.checkoutAvailability.payment_methods
  },
  checkoutTotalProduct (state) {
    if (!isObjectNotEmptyOrNull(state.checkoutAvailability)) {
      return 0
    }

    if (!isObjectNotEmptyOrNull(state.checkoutAvailability.available_carts)) {
      return 0
    }

    let totalProduct = 0

    state.checkoutAvailability.available_carts.store_branches.forEach((branch) => {
      totalProduct += branch.carts.length
    })

    return totalProduct
  }
}

export const actions = {
  getScheduleStoreBranch ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      CheckoutServices.getScheduleStoreBranch(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          if (response.status === 200) {
            commit(
              'setScheduleStoreBranch',
              response.data.data.store_branch_schedule
            )
          }
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  getStoreBranch ({ commit }, payload) {
    commit('setLoading', true)
    return new Promise((resolve, reject) => {
      CheckoutServices.getStoreBranch(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          if (response.status === 200) {
            commit('setStoreBranch', response.data.data.store_branches)
          }
          commit('setLoading', false)
          resolve(response)
        })
        .catch((error) => {
          commit('setLoading', false)
          console.log(error)
          reject(error)
        })
    })
  },
  getStoreBranchPAS ({ commit }, payload) {
    commit('setLoading', true)
    return new Promise((resolve, reject) => {
      CheckoutServices.getStoreBranch(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          if (response.status === 200) {
            commit('setStoreBranchPAS', response.data.data.store_branches)
          }
          commit('setLoading', false)
          resolve(response)
        })
        .catch((error) => {
          commit('setLoading', false)
          console.log(error)
          reject(error)
        })
    })
  },
  getProductStoreBranch ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      CheckoutServices.getProductStoreBranch(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload.id,
        payload
      )
        .then((response) => {
          if (response.status === 200) {
            commit('setProductStoreBranch', response.data.data)
          }
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  getShippingCourier ({ commit }, payload) {
    const key = requestKey(payload)
    if (courierRequest && courierRequest.key === key) { return courierRequest.promise }

    cancelRequest(courierRequest)

    const request = {
      key,
      generation: ++courierGeneration,
      source: axios.CancelToken.source(),
      resolve: null
    }
    commit('setShippingCourierLoading', true)
    commit('setShippingCourierError', false)
    request.promise = new Promise((resolve, reject) => {
      request.resolve = resolve
      CheckoutServices.getShippingCourier(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        { ...payload, cancelToken: request.source.token }
      )
        .then((response) => {
          if (request.generation === courierGeneration && response.status === 200) {
            commit('setShippingCourier', response.data.data)
            resolve(response)
          } else {
            if (request.generation === courierGeneration) {
              commit('setShippingCourierError', true)
            }
            resolve(null)
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) { return resolve(null) }
          if (request.generation === courierGeneration) {
            commit('setShippingCourierError', true)
          }
          reject(error)
        })
        .finally(() => {
          if (courierRequest === request) {
            courierRequest = null
            commit('setShippingCourierLoading', false)
          }
        })
    })
    courierRequest = request
    return request.promise
  },
  getListPayment ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      CheckoutServices.getListPayment(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          if (response.status === 200) {
            commit('setListPaymentMethods', response.data.data.payment_methods)
          }
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  getItemAvailability ({ commit }, payload) {
    commit('setOnCheck')
    return new Promise((resolve, reject) => {
      CheckoutServices.getItemAvailability(
        {
          loggedIn: this.$auth.loggedIn,
          value: this.$auth.loggedIn
            ? this.$auth.getToken(this.$auth.strategy.name)
            : this.$cookies.get('session_id') || ''
        },
        payload
      )
        .then((response) => {
          if (response.status === 200) {
            commit('setAvailibility', response.data.data.checkout)
            commit(
              'setListPaymentMethods',
              response.data.data.checkout.payment_methods || []
            )
          }
          commit('setOnCheck')
          resolve(response)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  getCheckoutAvailability ({ commit }, payload) {
    const { updateMethodAvailability = true, ...requestPayload } = payload
    const key = requestKey(payload)
    if (availabilityRequest && availabilityRequest.key === key) { return availabilityRequest.promise }

    cancelRequest(availabilityRequest)
    commit('setCheckoutAvailabilityLoading', true)

    const request = {
      key,
      generation: ++availabilityGeneration,
      source: null,
      timer: null,
      resolve: null
    }
    request.promise = new Promise((resolve, reject) => {
      request.resolve = resolve
      request.timer = setTimeout(() => {
        request.source = axios.CancelToken.source()
        CheckoutServices.getCheckoutAvailability(
          {
            loggedIn: this.$auth.loggedIn,
            value: this.$auth.loggedIn
              ? this.$auth.getToken(this.$auth.strategy.name)
              : this.$cookies.get('session_id') || ''
          },
          { ...requestPayload, cancelToken: request.source.token }
        )
          .then((response) => {
            if (request.generation === availabilityGeneration && response.status === 200) {
              commit('setCheckoutAvailability', response.data.data.checkout)
              if (updateMethodAvailability) {
                commit('setCheckoutMethodAvailability', {
                  shipping: response.data.data.checkout.shipping_is_available,
                  pickup: response.data.data.checkout.pickup_is_available
                })
              }
              commit('setAvailableCartsForm', {
                availableCarts: response.data.data.checkout.available_carts,
                checkoutGroups: requestPayload.data.checkout_groups
              })
              commit('setPaymentDetail', response.data.data.checkout.payment)
              commit('setCheckoutMethodChanging', false)
              resolve(response)
            } else {
              resolve(null)
            }
          })
          .catch((error) => {
            if (axios.isCancel(error)) { return resolve(null) }
            reject(error)
          })
          .finally(() => {
            if (availabilityRequest === request) {
              availabilityRequest = null
              commit('setCheckoutAvailabilityLoading', false)
            }
          })
      }, 500)
    })
    availabilityRequest = request
    return request.promise
  }
}
